export enum ClientStatusFilter {
  All,
  Active,
  Archived,
}
